//
//  app-vue.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import Vue from 'vue';

export default class AppVue extends Vue {

    /*
     * Handle style for i18n v-html strings.
     */
    protected handleCssStyle(): void {

        const important: NodeListOf<HTMLElement> = this.$el.querySelectorAll('.important');

        important.forEach((element: HTMLElement) => {

            element.style.borderBottom = '1px solid white';
            element.style.fontFamily = 'BentonSans-Bold';

        });

        const underlined: NodeListOf<HTMLElement> = this.$el.querySelectorAll('.underlined');

        underlined.forEach((element: HTMLElement) => {

            element.style.borderBottom = '1px solid white';

        });

    }

}
